<template>
  <div class="flex">
    <router-link :to="{ name: 'floorplan' }" v-slot="{ isActive }">
      <div
        v-if="floorplanIds.length > 0"
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="floorplan" />
      </div>
    </router-link>
    <router-link :to="{ name: 'delivery' }" v-slot="{ isActive }">
      <div
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="bike" />
      </div>
    </router-link>
    <router-link :to="{ name: 'takeAway' }" v-slot="{ isActive }">
      <div
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="take-away" />
      </div>
    </router-link>
    <router-link :to="{ name: 'tabs' }" v-slot="{ isActive }">
      <div
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="cards" />
      </div>
    </router-link>
    <router-link :to="{ name: 'reservations' }" v-slot="{ isActive }">
      <div
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="calendar" />
      </div>
    </router-link>
    <router-link :to="{ name: 'fastMode' }" v-slot="{ isActive }">
      <div
        v-if="config.fastMode && !isMobile"
        class="px-3 sm:px-6 py-2 rounded-full transition-colors cursor-pointer"
        :class="{
          'bg-v-300': isActive
        }"
      >
        <l-icon size="medium" name="fast-pos" />
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { RouterLink } from 'vue-router'

import { LIcon } from '@last/core-ui/paprika'

import { useConfigStore } from '@/store/config'
import { useFloorplanStore } from '@/store/floorplan'
import { isMobile } from '@/utils/isMobile'

const floorplanStore = useFloorplanStore()
const configStore = useConfigStore()
const { floorplanIds } = storeToRefs(floorplanStore)
const { config } = storeToRefs(configStore)
</script>
